(() => {
  const dialog = document.getElementById('GloweOffer');
  const trigger = document.querySelector('.gw-offer-trigger');
  if (!dialog || !trigger || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  let timer;
  let previousFocus;
  const open = () => {
    clearTimeout(timer);
    if (dialog.open) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    (dialog.querySelector('[data-offer-success]') || dialog.querySelector('input[type=email]'))?.focus();
  };
  trigger.hidden = false;
  trigger.addEventListener('click', open);
  dialog.querySelector('.gw-offer-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    const bounds = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (previousFocus instanceof HTMLElement && previousFocus !== document.body && previousFocus.isConnected) previousFocus.focus();
    else trigger.focus();
  });
  if (dialog.querySelector('[data-offer-success], [data-offer-error]')) open();
  else {
    const seenKey = 'gloweNewsletterPopupSeen';
    try {
      if (localStorage.getItem(seenKey) !== null) return;
      timer = setTimeout(() => {
        try {
          // Recheck in case another storefront tab displayed it during the delay.
          if (localStorage.getItem(seenKey) !== null) return;
          open();
          localStorage.setItem(seenKey, 'true');
        } catch {
          // Storage restrictions must not interfere with manual opening or signup.
        }
      }, 5000);
    } catch {
      // Without persistent storage, keep the manual button available without auto-opening.
    }
  }
})();
